import { render, staticRenderFns } from "./productChange.vue?vue&type=template&id=abf76346&scoped=true"
import script from "./productChange.vue?vue&type=script&lang=js"
export * from "./productChange.vue?vue&type=script&lang=js"
import style0 from "./productChange.vue?vue&type=style&index=0&id=abf76346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf76346",
  null
  
)

export default component.exports